import { GridItem, Text, VStack } from "@chakra-ui/react";
import { formatDate } from "@syla/shared/helpers/formatting";
import {
  PlanStatus,
  getSubscriptionState,
} from "@syla/shared/types/helpers/subscriptions";
import { SubscriptionWithPlansAndAccess } from "@syla/shared/types/responses/GetSubscriptionsResponse";
import React, { Fragment } from "react";

interface PlanRenewalDateProps {
  subscription?: SubscriptionWithPlansAndAccess<string>;
}

export const PlanRenewalDate = ({ subscription }: PlanRenewalDateProps) => {
  if (!subscription) {
    return null;
  }

  const subscriptionStatus = subscription && getSubscriptionState(subscription);

  if (subscriptionStatus.planStatus === PlanStatus.Expired) {
    return null;
  }

  const header =
    subscriptionStatus.planStatus === PlanStatus.Cancelled ?
      "Plan expiry date"
    : "Renewal Date";

  const description =
    subscriptionStatus.planStatus === PlanStatus.Cancelled ?
      "Your plan will expire on this date"
    : "Your plan will renew on this date for another year";

  const planDate =
    subscriptionStatus ?
      formatDate(
        (
          [
            PlanStatus.Active,
            PlanStatus.DowngradeScheduled,
            PlanStatus.RequiresAction,
          ].includes(subscriptionStatus.planStatus)
        ) ?
          subscriptionStatus.renewsOn
        : subscriptionStatus.lapsesOn,
      )
    : undefined;

  if (!planDate) {
    return null;
  }

  return (
    <>
      <GridItem>
        <VStack alignItems="flex-start">
          <Text fontWeight="bold">{header}</Text>
          <Text>{description}</Text>
        </VStack>
      </GridItem>

      <GridItem>
        <Text>{planDate}</Text>
      </GridItem>
    </>
  );
};
